import BaseBlockMap from './BaseBlockMap';
import ScenarioChooserBlockMap from './ScenariochooserBlockMap';


export default {
    ...BaseBlockMap,
    ...ScenarioChooserBlockMap,
};
